import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    name: 'serviceTypeList',
    initialState: {
        serviceTypes: [],
        total: 0,
        pageCount: 0,
        page: 0,
        pageSize: 10,
        serviceTypesError: null,
        loading: false
    },
    reducers: {
        setServiceTypes: (state, action) => {
            state.serviceTypes = action.payload.data;
            state.total = action.payload.total;
            state.pageCount = action.payload.page_count;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setServiceTypesError: (state, action) => {
            state.serviceTypesError = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setServiceTypes,
    setPage,
    setPageSize,
    setServiceTypesError,
    setLoading,
} = slice.actions;
export const serviceTypesListReducer = slice.reducer;